import LogoutIcon from "@mui/icons-material/Logout";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton
} from "@mui/material";
import { useKeycloak } from "@react-keycloak/web";
import React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export interface LogoutProps {
  color: string;
}

const Logout = ({ color }: LogoutProps) => {
  const { keycloak } = useKeycloak();
  const { t } = useTranslation();
  const [openLogoutModal, setOpenLogoutModal] = useState(false);

  const handleCloseLogoutModal = () => {
    setOpenLogoutModal(false);
  };

  const onLogout = () => {
    setOpenLogoutModal(true);
  };

  return (
    <React.Fragment>
      <IconButton onClick={onLogout} disabled={!keycloak.authenticated}>
        <Box
          sx={{
            backgroundColor: "red",
            color: "white",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 20,
            width: 35,
            height: 35
          }}
        >
          <LogoutIcon sx={{ color: "white" }} />
        </Box>
      </IconButton>
      <Dialog
        open={openLogoutModal}
        onClose={handleCloseLogoutModal}
        aria-labelledby="logout-dialog-title"
      >
        <DialogTitle id="logout-dialog-title">
          {t("navbar.logout.title")}
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleCloseLogoutModal} variant="outlined">
            {t("navbar.logout.cancel")}
          </Button>
          <Button
            onClick={() => keycloak.logout()}
            autoFocus
            variant="contained"
            color="error"
          >
            {t("navbar.logout.confirm")}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
export default Logout;
